<template>
  <div class="fill-height">


    <v-card class="fill-height">
      <v-card-title  class="p-1">
        <v-chip
            label    small
            class="ma-2"
            color="secondary">
          قالب های  جدید
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <template-sms-manager-confirm :model="model" :dialogStatus.sync="showDialog"/>
        <v-row>


          <v-col cols="12">
            <b-table
                v-if="can('confirmTemplateSms')"
                :items="dataItems"
                :fields="columns"
                :per-page=0
                stacked="md"
                show-empty
                striped
            >
              <template #cell(statusText)="row">
                <v-chip :color="row.item.color" label outlined   small>{{ row.item.statusText}}</v-chip>
              </template>
              <template #cell(actions)="row">
                <v-btn depressed small v-if="can('confirmTemplateSms')" color="primary" @click="forEdit(row.item)" class="mr-1 ">
                  مشاهده
                </v-btn>

              </template>
            </b-table>

          </v-col>

        </v-row>

      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import TemplateSmsManagerConfirm from './PageEdit'
import Servise_se from "./Servise_se";
import {mapMutations} from "vuex";



export default {
  name: 'RequestTemplateSmsManager',
  components: {
    TemplateSmsManagerConfirm
  },
  data() {
    return {
      searchvalue: '',
      modelId: '',
      model: {},
      showDialog: false,
      modelAtributes: {},
      dataItems: [],
      columns: [
        {key: 'templateTypeTxt', label: 'نوع قالب',},
        {key: 'building', label: 'مجتمع', sortable: true, sortDirection: 'desc'},
        {key: 'templateEn', label: 'نام قالب به انگلیسی', },
        {key: 'templateFa', label: 'نام قالب به فارسی', },
        {key: 'statusText', label: 'وضعیت', },
        {key: 'actions', label: 'عملیات'}
      ],

    };

  },

  mounted() {
    this.$root.$on('RequestTemplateSmsManager', () => {

      this.fillDataItems()
    })

  },

  methods: {
    close(){
      this.searchvalue=""
      this.$router.push('/home')
    },
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),

    fetch() {
      Servise_se.getById(this.modelId).then(response => {
        this.model = response.data.model
      })
      this.showDialog = true;
    },
    forEdit: function (e) {
      this.modelId = e.id;
      this.fetch()
    },




    pageChangeHandler: function (event) {
      this.skip = event;
      this.fillDataItems();

    },

    fillDataItems() {
      Servise_se.getPage().then(response => {
        this.dataItems = response.data.requestList

      });
    },



  },

  created() {
   this.setDrawer(false)
    this.fillDataItems();
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
